// index

let dt_categories = null;

export function index(){
    
    dt_categories = $('#categories_table').DataTable({
        ajax: {
            url: $('#categories_table').attr('url'),
        },
        columns: [
            { width: '20', data: null, orderable: false, searchable: false, class: 'actions', render: render_actions },
            { data: 'name', orderable: true, searchable: true },
        ],
        order: [[1, 'asc']],
        pageLength: 50,
    });
    
}

function render_actions(data, type, row){
    const url_info = ($("#categories_table").attr('url_info') ?? '').replace('#', row.id);
    
    const actions = 
    '<div class="btn-group" role="group">' +
    '   <a class="btn btn-primary btn-xs show ajax" href="' + url_info + '">' + window.__('info') + '</a>' +
    '</div>';
    
    return actions;
}

// show

export function show(){

}
